/**
 * Press Releases Load More
 * Handles frontend pagination of server-rendered press releases
 */
export function initPressReleasesLoadMore() {
    const container = document.querySelector('[data-press-releases-container]');
    if (!container) return;

    const itemsList = container.querySelector('[data-press-releases-list]');
    const paginationContainer = container.querySelector('[data-pagination-container]');
    const loadMoreBtn = container.querySelector('[data-load-more-btn]');
    const loadingState = container.querySelector('[data-loading-state]');

    if (!itemsList) return;

    const dictionary = window.dictionary || {
        loading: 'Loading...',
        loadMore: 'Load more'
    };

    const pageSize = parseInt(container.dataset.limit || '20');
    const allItems = Array.from(itemsList.querySelectorAll('.press-release-item'));
    const delayMs = 400;
    let visibleCount = pageSize;
    let isLoading = false;

    const yearSelect = container.querySelector('[data-year-select]');
    if (yearSelect) {
        yearSelect.addEventListener('change', () => {
            const params = new URLSearchParams(window.location.search);
            if (yearSelect.value) {
                params.set('year', yearSelect.value);
            } else {
                params.delete('year');
            }
            window.location.search = params.toString();
        });
    }

    if (loadingState) {
        loadingState.classList.add('hidden');
        loadingState.style.display = 'none';
        loadingState.setAttribute('aria-busy', 'false');
    }

    if (!allItems.length) {
        if (paginationContainer) {
            paginationContainer.classList.add('hidden');
        }
        return;
    }

    const updatePaginationState = () => {
        allItems.forEach((item, index) => {
            item.classList.toggle('hidden', index >= visibleCount);
        });

        const hasMore = visibleCount < allItems.length;
        if (paginationContainer) {
            paginationContainer.classList.toggle('hidden', !hasMore);
        }
    };

    updatePaginationState();

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', async (event) => {
            event.preventDefault();
            if (isLoading) return;

            isLoading = true;
            loadMoreBtn.disabled = true;
            loadMoreBtn.classList.add('opacity-50', 'cursor-not-allowed');
            loadMoreBtn.textContent = dictionary.loading;

            if (loadingState) {
                loadingState.classList.remove('hidden');
                loadingState.style.display = 'flex';
                loadingState.setAttribute('aria-busy', 'true');
            }

            await new Promise(resolve => setTimeout(resolve, delayMs));

            visibleCount += pageSize;
            updatePaginationState();

            if (loadingState) {
                loadingState.classList.add('hidden');
                loadingState.style.display = 'none';
                loadingState.setAttribute('aria-busy', 'false');
            }

            loadMoreBtn.disabled = false;
            loadMoreBtn.classList.remove('opacity-50', 'cursor-not-allowed');
            loadMoreBtn.textContent = dictionary.loadMore;
            isLoading = false;
        });
    }
}

